import PropTypes from 'prop-types';

import {
  Or,
  ResultsColumn,
  ResultsLeftHeader,
  ResultsLeftSubHeader,
  QuietZoneTable,
  ResultsTitle,
  TextPink,
  TwoRowsColumn,
  UpTo,
} from './styles';
import { connectLocation } from '../../location/LocationConnectors';

const QuietZoneResults = connectLocation(({ results, t, locale }) => {
  const { nextGen, mineralWool } = results;
  const { code } = locale;

  return (
    <ResultsColumn>
      <ResultsTitle>{t('insulation.commercial.quietzone.results.title')}</ResultsTitle>
      <QuietZoneTable>
        <thead>
          <tr>
            <th> </th>
            <th>
              {code === 'fr-CA' ? (
                <>
                  Matelas insonorisants ROSE NEXT GEN<sup>MC</sup> FIBERGLAS<sup>MD</sup> Quiétude<sup>MD</sup>
                </>
              ) : (
                <>QuietZone&#174; PINK NEXT Gen&#174; Fiberglas&#174; Acoustic Insulation</>
              )}
            </th>
            <th>
              {t('insulation.commercial.quietzone.results.mineral_wool')}
              <sup>^</sup>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ResultsLeftHeader>{t('insulation.commercial.quietzone.results.bags_required')}</ResultsLeftHeader>
              <ResultsLeftSubHeader>
                {t('insulation.commercial.quietzone.results.bags_required_sub')}
              </ResultsLeftSubHeader>
            </td>
            <td>
              <TextPink>
                <strong>{nextGen.bagsInsulationRequired || '-'}</strong>
              </TextPink>
            </td>
            <td>{mineralWool.bagsInsulationRequired || '-'}</td>
          </tr>
          <tr>
            <td>
              <ResultsLeftHeader>{t('insulation.commercial.quietzone.results.fiber_used')}</ResultsLeftHeader>
              <ResultsLeftSubHeader>
                {t('insulation.commercial.quietzone.results.fiber_used_sub_1')}
                <sup>3</sup> {t('insulation.commercial.quietzone.results.fiber_used_sub_2')}
                <sup>3</sup>
              </ResultsLeftSubHeader>
              <Or>{t('insulation.commercial.quietzone.results.or')}</Or>
              <ResultsLeftHeader>{t('insulation.commercial.quietzone.results.tons_fiber_used')}</ResultsLeftHeader>
              <ResultsLeftSubHeader>
                {t('insulation.commercial.quietzone.results.tons_fiber_used_sub_1')}
                <sup>2</sup> {t('insulation.commercial.quietzone.results.tons_fiber_used_sub_2')}
                <sup>2</sup>
              </ResultsLeftSubHeader>
            </td>
            <td>
              <TwoRowsColumn>
                <p>
                  <TextPink>
                    <strong>{nextGen.poundsFiberUsed || '-'}</strong>
                  </TextPink>
                </p>
                <p>
                  <TextPink>
                    <strong>{nextGen.metricTonsFiberUsed || '-'}</strong>
                  </TextPink>
                </p>
              </TwoRowsColumn>
            </td>
            <td>
              <TwoRowsColumn>
                <p>{mineralWool.poundsFiberUsed || '-'}</p>
                <p>{mineralWool.metricTonsFiberUsed || '-'}</p>
              </TwoRowsColumn>
            </td>
          </tr>
          <tr>
            <td>
              <ResultsLeftHeader>
                {t('insulation.commercial.quietzone.results.co2_emitted_1')}
                <sub>2</sub> {t('insulation.commercial.quietzone.results.co2_emitted_2')}
              </ResultsLeftHeader>
              <ResultsLeftSubHeader>
                {t('insulation.commercial.quietzone.results.during_transportation')}
                <sup>‡</sup>
              </ResultsLeftSubHeader>
            </td>
            <td>
              {nextGen.tonsCO2Emitted ? (
                <>
                  <UpTo>{t('insulation.commercial.quietzone.results.up_to')}</UpTo>
                  <TextPink>
                    <strong>{nextGen.tonsCO2Emitted}</strong>
                  </TextPink>
                </>
              ) : (
                '-'
              )}
            </td>
            <td>
              {mineralWool.tonsCO2Emitted ? (
                <>
                  <UpTo>{t('insulation.commercial.quietzone.results.up_to')}</UpTo>
                  {mineralWool.tonsCO2Emitted}
                </>
              ) : (
                '-'
              )}
            </td>
          </tr>
        </tbody>
      </QuietZoneTable>
    </ResultsColumn>
  );
});

QuietZoneResults.propTypes = {
  results: PropTypes.shape({
    nextGen: PropTypes.shape({
      bagsInsulationRequired: PropTypes.number,
      poundsFiberUsed: PropTypes.number,
      metricTonsFiberUsed: PropTypes.number,
      tonsCO2Emitted: PropTypes.number,
    }),
    mineralWool: PropTypes.shape({
      bagsInsulationRequired: PropTypes.number,
      poundsFiberUsed: PropTypes.number,
      metricTonsFiberUsed: PropTypes.number,
      tonsCO2Emitted: PropTypes.number,
    }),
  }),
};

QuietZoneResults.defaultProps = {
  results: {
    nextGen: {},
    mineralWool: {},
  },
};

export default QuietZoneResults;
